import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material';

export interface LoadingIndicatorPropsType {
  sx?: SxProps;
  size?: number;
  showOverlay?: boolean;
  disableOutsideClick?: boolean;
}

export const LoadingIndicator = ({
  sx,
  size = 40,
  showOverlay = true,
  disableOutsideClick = true
}: LoadingIndicatorPropsType) => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: showOverlay ? 'rgba(0, 0, 0, 0.3)' : 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      pointerEvents: disableOutsideClick ? 'auto' : 'none',
      ...sx
    }}
  >
    <CircularProgress
      size={size}
      sx={{
        pointerEvents: 'auto'
      }}
    />
  </Box>
);
